/**
 * OpenTelemetry instrumentation for backoffice
 * Exports traces to Grafana Cloud via backend OTLP proxy
 * Uses /otlp/traces endpoint to avoid CORS issues with Grafana's OTLP gateway
 */
import { WebTracerProvider, BatchSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
export function initializeOpenTelemetry() {
    // Get OTLP configuration from environment (Webpack DefinePlugin injects these)
    // Use typeof check to avoid ReferenceError if process is not defined
    const otlpEndpoint = typeof process !== 'undefined' ? process.env.REACT_APP_OTEL_EXPORTER_OTLP_ENDPOINT : undefined;
    const serviceName = (typeof process !== 'undefined' ? process.env.REACT_APP_OTEL_SERVICE_NAME : undefined) || 'backoffice';
    const environment = (typeof process !== 'undefined' ? process.env.REACT_APP_OTEL_DEPLOYMENT_ENVIRONMENT : undefined) || 'production';
    if (!otlpEndpoint) {
        console.warn('[OTEL] Missing OTLP configuration, skipping instrumentation');
        return;
    }
    // Create OTLP exporter pointing to backend proxy
    // No auth headers needed - backend proxy adds them when forwarding to Grafana
    const exporter = new OTLPTraceExporter({
        url: otlpEndpoint,
    });
    // Create batch span processor
    const spanProcessor = new BatchSpanProcessor(exporter);
    // Create tracer provider with span processor
    const provider = new WebTracerProvider({
        spanProcessors: [spanProcessor],
    });
    // Register the provider
    provider.register();
    // Auto-instrument fetch and XHR
    registerInstrumentations({
        instrumentations: [
            new FetchInstrumentation({
                propagateTraceHeaderCorsUrls: [
                    /^https:\/\/api\.ksymmetry\.(app|com)/,
                    /^http:\/\/localhost/,
                ],
            }),
            new XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: [
                    /^https:\/\/api\.ksymmetry\.(app|com)/,
                    /^http:\/\/localhost/,
                ],
            }),
        ],
    });
    console.log(`[OTEL] Initialized for service="${serviceName}" environment="${environment}"`);
}
